// extracted by mini-css-extract-plugin
module.exports = {"form":"QuoteForm_form__1mVF_","loading":"QuoteForm_loading__1GTWm","control":"QuoteForm_control__a6dm7","actions":"QuoteForm_actions__2xv5Q"};